var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeorgia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_6333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_6333",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_6333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 3H1V23H35.2819V3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12856 7.51289C9.10847 7.88115 9.07499 8.24272 9.02143 8.59759C9.00134 8.71142 8.98125 8.82524 8.96117 8.93907C9.18212 8.91228 9.40978 8.89889 9.64413 8.89889C9.87178 8.89889 10.0994 8.91228 10.3271 8.93907C10.307 8.82524 10.2869 8.71142 10.2668 8.59759C10.2133 8.24272 10.1731 7.88115 10.1597 7.51289C10.6485 7.53298 11.1239 7.59324 11.5859 7.68028C11.5591 7.45932 11.5457 7.23167 11.5457 6.99732C11.5457 6.76297 11.5591 6.54201 11.5859 6.31436C11.1172 6.4014 10.6418 6.46167 10.1597 6.48175C10.1798 5.99297 10.24 5.51757 10.3271 5.05557C10.1061 5.08236 9.87847 5.09575 9.64413 5.09575C9.40978 5.09575 9.18882 5.08236 8.96117 5.05557C9.04821 5.52427 9.10847 5.99966 9.12856 6.48175C8.63977 6.46167 8.16438 6.4014 7.70238 6.31436C7.72916 6.53532 7.74255 6.76297 7.74255 6.99732C7.74255 7.22497 7.72916 7.45263 7.70238 7.68028C8.16438 7.59324 8.64647 7.53298 9.12856 7.51289Z",
    fill: "#D51F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1289 7.51289C26.1088 7.88115 26.0753 8.24272 26.0217 8.59759C26.0017 8.71142 25.9816 8.82524 25.9615 8.93907C26.1824 8.91228 26.4101 8.89889 26.6444 8.89889C26.8721 8.89889 27.0998 8.91228 27.3274 8.93907C27.3073 8.82524 27.2872 8.71142 27.2671 8.59759C27.2136 8.24272 27.1734 7.88115 27.16 7.51289C27.6488 7.53298 28.1242 7.59324 28.5929 7.68028C28.5661 7.45932 28.5527 7.23167 28.5527 6.99732C28.5527 6.76297 28.5661 6.54201 28.5929 6.31436C28.1242 6.4014 27.6488 6.46167 27.16 6.48175C27.1868 5.99297 27.2404 5.51757 27.3274 5.05557C27.1064 5.08236 26.8788 5.09575 26.6444 5.09575C26.4101 5.09575 26.1891 5.08236 25.9615 5.05557C26.0485 5.52427 26.1088 5.99966 26.1289 6.48175C25.6401 6.46167 25.1647 6.4014 24.7027 6.31436C24.7295 6.53532 24.7429 6.76297 24.7429 6.99732C24.7429 7.22497 24.7295 7.45263 24.7027 7.68028C25.1647 7.59324 25.6401 7.53298 26.1289 7.51289Z",
    fill: "#D51F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.153 18.4871C10.1731 18.1188 10.2066 17.7573 10.2601 17.4024C10.2802 17.2886 10.3003 17.1747 10.3204 17.0609C10.0994 17.0877 9.87179 17.1011 9.63744 17.1011C9.40309 17.1011 9.18214 17.0877 8.95448 17.0609C8.97457 17.1747 8.99466 17.2886 9.01474 17.4024C9.06831 17.7573 9.10848 18.1188 9.12187 18.4871C8.63309 18.4603 8.1577 18.4067 7.69569 18.3197C7.72248 18.5407 7.73587 18.7683 7.73587 19.0027C7.73587 19.2303 7.72248 19.458 7.69569 19.6856C8.16439 19.5986 8.63979 19.5383 9.12187 19.5182C9.10179 20.007 9.04153 20.4824 8.95448 20.9511C9.17544 20.9243 9.40309 20.9109 9.63744 20.9109C9.86509 20.9109 10.0927 20.9243 10.3204 20.9511C10.2334 20.4824 10.1731 20.007 10.153 19.5182C10.6418 19.545 11.1172 19.5986 11.5792 19.6856C11.5524 19.4647 11.539 19.237 11.539 19.0027C11.539 18.7683 11.5524 18.5474 11.5792 18.3197C11.1172 18.4 10.6418 18.4603 10.153 18.4871Z",
    fill: "#D51F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1533 18.4871C27.1734 18.1188 27.2069 17.7573 27.2605 17.4024C27.2806 17.2886 27.3006 17.1747 27.3207 17.0609C27.0998 17.0877 26.8721 17.1011 26.6378 17.1011C26.4034 17.1011 26.1825 17.0877 25.9548 17.0609C25.9749 17.1747 25.995 17.2886 26.0151 17.4024C26.0686 17.7573 26.1088 18.1188 26.1222 18.4871C25.6334 18.4603 25.158 18.4067 24.696 18.3197C24.7228 18.5407 24.7362 18.7683 24.7362 19.0027C24.7362 19.2303 24.7228 19.458 24.696 19.6856C25.1647 19.5986 25.6401 19.5383 26.1222 19.5182C26.1021 20.007 26.0419 20.4824 25.9548 20.9511C26.1758 20.9243 26.4034 20.9109 26.6378 20.9109C26.8654 20.9109 27.0931 20.9243 27.3207 20.9511C27.2337 20.4824 27.1734 20.007 27.1533 19.5182C27.6421 19.545 28.1175 19.5986 28.5862 19.6856C28.5594 19.4647 28.546 19.237 28.546 19.0027C28.546 18.7683 28.5594 18.5474 28.5862 18.3197C28.1175 18.4 27.6354 18.4603 27.1533 18.4871Z",
    fill: "#D51F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1563 3H16.1255V23H20.1563V3Z",
    fill: "#D51F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 10.9812H1V15.012H35.2819V10.9812Z",
    fill: "#D51F3A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_6333",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_6333"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_6333",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeorgia);
export default __webpack_public_path__ + "static/media/Georgia.a2bb049d28b8590bad07431b310946e1.svg";
export { ForwardRef as ReactComponent };